import { FormFieldValidator, FormFieldDefinition, FormDefinition  } from '@feature/_app_modules/dynamic-forms/dynamic-form';
import { WidgetConfiguration } from '@feature/widget-configs';
import { QueryBuilderConfig } from 'ngx-angular-query-builder';
import { IColumnDefinition } from '@common/index';
import { IManagementType } from '@common/models/management-type';

/**
 * Returns a default widgetconfig admin form
 */
export function getDefaultWidgetConfigAdminForm(widgetConfig: WidgetConfiguration): FormDefinition {
  return {
    key: 'WidgetEditor',
    fields:
      [
        {
          key: 'name',
          label: 'Name',
          placeholder: 'Enter widget name',
          value: widgetConfig.name,
          type: 'text',
          disabled: false,
          options: null,
          validation:
            [],
          asyncValidation: [],
        } as FormFieldDefinition,
        {
          key: 'type',
          label: 'Type',
          placeholder: 'Enter widget type',
          value: widgetConfig.widgetTypeId,
          type: 'text',
          disabled: true,
          options: null,
          validation: [],
          asyncValidation: [],
        } as FormFieldDefinition,
        {
          key: 'title',
          label: 'Title',
          placeholder: 'Enter widget title',
          value: widgetConfig.title,
          type: 'text',
          options: null,
          validation:
            [
              { key: 'required', value: true, message: 'The title field is required' } as FormFieldValidator,
              { key: 'maxlength', value: 50, message: 'Max length (50) has been exceeded' } as FormFieldValidator
            ],
          asyncValidation: [],
        } as FormFieldDefinition,
        {
          key: 'description',
          label: 'Description',
          value: widgetConfig.description,
          type: 'multiline',
          placeholder: 'Enter description',
          options: null,
          validation:
            [
              { key: 'required', value: true, message: 'The description field is required' },
              { key: 'maxlength', value: 150, message: 'Max length (150) has been exceeded' }
            ],
          asyncValidation: [],
        } as FormFieldDefinition,

      ] as Array<FormDefinition | FormFieldDefinition>,
    validation: [],
    asyncValidation: [],
  } as FormDefinition;
}

export function addFilterFieldsToAdminForm(widgetConfig: WidgetConfiguration,
  queryBuilderConfig: QueryBuilderConfig,
  adminForm: FormDefinition): FormDefinition {

  if (queryBuilderConfig != null) {
    const filter = (widgetConfig.filter
      ? widgetConfig.filter
      : {
        condition: 'and',
        rules: []
      });
    queryBuilderConfig.allowEmptyRulesets = true;
    adminForm.fields.push(
      {
        key: 'filter',
        label: 'Filters',
        value: filter,
        type: 'queryBuilder',
        options: queryBuilderConfig,
        validation: [
          { key: 'validateFilter', value: true, message: 'Please ensure a valid filter option has been selected' }
        ],
        asyncValidation: [],
      } as FormFieldDefinition
    );
  }
  return adminForm;
}

export function addColumnFieldsToAdminForm(widgetConfig: WidgetConfiguration,
  columns: IColumnDefinition[],
  adminForm: FormDefinition,
  label: string = 'Columns'): FormDefinition {

  if (columns != undefined && columns.length > 0) {

    if (widgetConfig.selectedColumns == undefined) {
      widgetConfig.selectedColumns = [];
    }

    adminForm.fields.push(
      {
        key: 'selectedColumns',
        label: label,
        value: widgetConfig.selectedColumns.filter(i => !i.IsSystemColumn), // HACK: MP-1831
        type: 'multiSelect',
        dataKey: 'Field',
        optionLabel: 'Header',
        options: columns,
        validation: [],
        asyncValidation: [],
      } as FormFieldDefinition
    );

  }
  return adminForm;

}

export function addManagementTypesToAdmin(widgetConfig: WidgetConfiguration,
  managementTypes: IManagementType[],
  adminForm: FormDefinition): FormDefinition {

  if (widgetConfig.selectedManagerCodes == undefined) {
    widgetConfig.selectedManagerCodes = [];
  }
  const selectedManagerTypes = managementTypes.filter(x => {
    return widgetConfig.selectedManagerCodes.indexOf(x.Code) > -1;
  });

  for (let managementType of managementTypes) {
    managementType.DisplayName = managementType.Code + ' - ' + managementType.Description;
  }

  adminForm.fields.push(
    {
      key: 'selectedManagerCodes',
      label: 'Property Manager Type',
      value: selectedManagerTypes,
      type: 'multiSelect',
      dataKey: 'Code',
      optionLabel: 'DisplayName',
      options: managementTypes,
      validation: [{ key: 'required', value: true, message: 'At least one Property Manager Type must be selected' } as FormFieldValidator],
      asyncValidation: [],
    } as FormFieldDefinition
  );

  return adminForm;

}
